document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[data-media-update]');
  const container = document.querySelector('[data-main-media-container]');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const mediaData = button.dataset.mediaUpdate;
      const handle = button.dataset.productHandle;

      if (!mediaData || !handle) return;

      let media;
      try {
        media = JSON.parse(mediaData.replace(/&quot;/g, '"'));
      } catch (e) {
        console.error('Invalid media JSON', e);
        return;
      }

      console.log('Media JSON:', media);

      fetch(`/products/${handle}?view=media&media_id=${media.id}`)
        .then(res => res.text())
        .then(html => {
          container.innerHTML = html;
        })
        .catch(console.error);
    });
  });
});